import {themr} from '@friendsofreactjs/react-css-themr';
import identifiers from '../identifiers';

import IconButton from './iconButton';
import style from  './style.css';

export default themr(identifiers.iconButton, style)(IconButton);
